<template>
    <div class='txxsc box' v-if='!isLoading'>
        <table class='show'>
            <colgroup width='160px'></colgroup>
            <tr>
                <td>投标单位</td>
                <td>{{tbdw.companyName}}</td>
            </tr>
            <tr>
                <td>中标候选人</td>
                <td>{{tbdw.winningCandidateState=='0'?"未入选":"已入选"}}</td>
            </tr>
        </table>
    </div>
    <div v-else class='loading'>
        <p>正在进行有效性审查，请耐心等待...</p>
        <div id="colorfulPulse">
            <span class='item-1'></span>
            <span class='item-2'></span>
            <span class='item-3'></span>
            <span class='item-4'></span>
            <span class='item-5'></span>
            <span class='item-6'></span>
            <span class='item-7'></span>
        </div>
    </div>
</template>
<script>
    export default {
        name:'tbzbhxr',
        props:['djlcId'],
        data(){
            return{
                tbdw:{},
                scfs:'1',
                isLoading:true
            }
        },
        methods:{
            getData(){
                let para={
                    djlcId:this.djlcId
                }
                this.$api.checkCompanyWinningCandidate(para).then(res=>{
                    if(res.data.meta.success){
                        this.tbdw=res.data.data
                        this.isLoading=false
                    }else{
                        this.$message({
                            type:'error',
                            message:res.data.meta.message
                        })
                        this.isLoading=false
                    }
                }).catch(()=>{})
            },
        },
        mounted(){
            this.getData();
        }
    }
</script>    